/*
 *   Copyright (c) 2020
 *   All rights reserved.
 */

import { handleActions } from 'redux-actions';
import produce from 'immer';
import * as types from '@src/store/types';

const initialState = {
	ssrPage: null,
	domain: '',
};

export default handleActions(
	{
		[types.SET_SSR_PAGE](state, { payload }) {
			return produce(state, draft => {
				draft.ssrPage = payload;
			});
		},
		[types.SET_DOMAIN](state, { payload }) {
			return produce(state, draft => {
				draft.domain = payload.domain;
			});
		},
	},
	initialState,
);
